import { SoundService as BaseSoundService } from '@pascal/pascal-core';
import { defaultSounds } from '@pascal/pascal-core/shared/core/services/sound/defaultSounds';

defaultSounds.betAccepted = null;
defaultSounds.win = null;
defaultSounds.music = null;

const SoundTypes = {
  Add: 'Add',
  Win: 'Win',
  Bet: 'Bet',
  Match: 'Match',
  BgMusic: 'Background_music',
  ClearDelete: 'Clear_delete',
  NumberSelection: 'Number_selection',
  CantSelect: 'Cant_Select',
};

const options = [
  {
    src: 'sounds/Background_music.mp3',
    name: SoundTypes.BgMusic,
    autoplay: true,
    html5: true,
    loop: true,
  },
  {
    src: 'sounds/Add.mp3',
    name: SoundTypes.Add,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/Cant_Select.mp3',
    name: SoundTypes.CantSelect,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/Win.mp3',
    name: SoundTypes.Win,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/Bet.mp3',
    name: SoundTypes.Bet,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/Match.mp3',
    name: SoundTypes.Match,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/Clear_delete.mp3',
    name: SoundTypes.ClearDelete,
    autoplay: false,
    html5: true,
  },
  {
    src: 'sounds/Number_selection.mp3',
    name: SoundTypes.NumberSelection,
    autoplay: false,
    html5: true,
  },
];

class SoundService extends BaseSoundService {
  constructor(props) {
    super(props);
  }

  playWin() {
    return super.play(SoundTypes.Win);
  }

  stopWin() {
    return super.stop(SoundTypes.Win);
  }

  playAdd() {
    return this.play(SoundTypes.Add);
  }

  playBgMusic() {
    return this.play(SoundTypes.BgMusic);
  }

  stopAdd() {
    return super.stop(SoundTypes.Add);
  }

  playBet() {
    return super.play(SoundTypes.Bet);
  }

  stopBet() {
    return super.stop(SoundTypes.Bet);
  }

  playMatch() {
    return super.play(SoundTypes.Match);
  }

  stopMatch() {
    return super.stop(SoundTypes.Match);
  }

  playClearDelete() {
    return super.play(SoundTypes.ClearDelete);
  }

  stopClearDelete() {
    return super.stop(SoundTypes.ClearDelete);
  }

  playNumberSelection() {
    return super.play(SoundTypes.NumberSelection);
  }

  playNumberCantSelection() {
    return super.play(SoundTypes.CantSelect);
  }

  stopNumberSelection() {
    return super.stop(SoundTypes.NumberSelection);
  }
}

const soundService = new SoundService({
  options,
});

export { soundService, SoundTypes as soundTypes };
